import {minmax, sectionToFixedMap, portrait, promo} from '../shared.js';
import {buildNarrativeTextTimeline, drawFrame, createFlipbook, scrubFlipbook} from '../animations.js';

const article = document.querySelector('#chapter7');

const narrativeSection = article.querySelector('#chapter7-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeTimeline = new TimelineLite({paused: true});
const narrativeText = narrativeFixed.querySelector('.narrative-text');

const infoSection = article.querySelector('#chapter7-flipbook');
const infoFixed = sectionToFixedMap.get(infoSection);
const flipbook = infoFixed.querySelector('.flipbook');
const figure = infoFixed.querySelector('figure');
const scrubList = flipbook.querySelectorAll('li');
const infoTimeline = new TimelineLite({paused: true});
const footnote = infoFixed.querySelector('.footnote');

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter7:init');

  narrativeSection.addEventListener('active', () => promo.classList.add('active'));
  narrativeSection.addEventListener('inactive', () => promo.classList.remove('active'));

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initInfo();
}

/**
 * Initialize infographic
 */
function initInfo() {
  const scrubStart = 125;
  const scrubEnd = 425;

  TweenLite.set([figure, footnote], {opacity: 0});

  infoSection.addEventListener('intersection', () => {
    const create = () => createFlipbook(flipbook, +article.dataset.chapter);
    portrait.addListener(create);
    create();
  }, {once: true});

  infoTimeline.to({}, 100, {});

  infoTimeline.to([footnote, figure], 25, {opacity: 1}, scrubStart + 125);

  infoSection.addEventListener('scrub', ({detail: {vh}}) => {
    infoTimeline.seek(minmax(0, vh, infoTimeline.duration()), false);

    let percent = (vh < scrubStart) ? 0 : (vh > scrubEnd) ? 1 : (vh - scrubStart) / (scrubEnd - scrubStart);

    scrubFlipbook(flipbook, percent);
  });
}
